// extracted by mini-css-extract-plugin
export var quillEditor = "_mz-1";
export var variable = "_mz-0";